<template>
  <div
    v-if="errorId && errorId !== ''"
    class="white elevation-3 mx-0 mt-0 mt-xl-6 pa-5 pa-xl-16"
    :class="$vuetify.breakpoint.xl ? 'rounded-lg' : 'rounded-0'"
  >
    <div class="d-flex justify-center">
      <div class="d-flex flex-column align-center content-wrapper">
        <div
          class="d-flex justify-center align-center rounded-circle mt-9 mb-6 icon-wrapper"
        >
          <v-icon color="white" size="32">mdi mdi-close</v-icon>
        </div>

        <h1 class="primary--text text-center mb-2">{{ errorTitle }}</h1>

        <p class="primary--text font-18 text-center mb-0">{{ errorMessage }}</p>

        <BaseButton
          color="psorange"
          depressed
          rounded
          width="180"
          height="60"
          :text="setButtonText"
          class="font-20 font-weight-bold mt-10 mb-9"
          @click="handleRedirect"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { QuestionStore } from "@/store/store";
import BaseButton from "@/components/BaseComponents/BaseButton";

export default {
  name: "ErrorPage",
  components: {
    BaseButton,
  },
  props: {
    errorId: {
      type: String,
      default: "",
    },
    errorTitle: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    redirectPath: {
      type: String,
      default: "",
    },
  },
  computed: {
    setButtonText() {
      return this.errorTitle.toLowerCase().includes("expired")
        ? "LOG IN"
        : "GO BACK";
    },
  },
  methods: {
    handleRedirect() {
      return this.redirectPath === "adviserHub"
        ? QuestionStore.dispatch("exitToAdviserHub")
        : QuestionStore.dispatch("exitToHomePage");
    },
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  max-width: 642px;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  background-color: #be0039;
  border: solid 12px #f8e5eb;
}
</style>
